import moment from 'moment'
import React, { cloneElement } from 'react'
import { withRouter } from 'react-router-dom'
import BaseCheckbox from '../BaseCheckbox'
import DashedLink from '../DashedLink'
import DefaultLink from '../DefaultLink'
import IconEdit from '../icons/IconEdit'
import IconTrashCan from '../icons/IconTrashCan'
import StatusPrint from '../statusPrint'


const TableBody = ({ data, options, actions, padding, keyProp }) => {


  const cellGenerator = (column, row, isOpen) => {
    switch (column.type) {
      case 'checkbox':
        return <BaseCheckbox
          checkboxId={row.partnum}
        />
      case 'component':
        return cloneElement(column.component, { row, isOpen, actions: actions ? actions[column.dataKey] : {} })
      case 'date':
        return moment(row[column.dataKey].split(' ')[0]).format('MM/DD/YYYY')
      case 'select':

        return <StatusPrint
          currentStatus={row[column.dataKey]}
          options={column.options}
          isReadOnly={column.isReadOnly}
          key={column.key}
          dataKey={column.dataKey}
          minWidth={column.minWidth}
          disabled={column.disabled}
          colorless={column.colorless}
        />


      case 'id':
        return '...' + row.UUID.slice(-4)
      case 'dashed-link':
        return <DashedLink name={column.label ? column.label : row[column.dataKey]} />
      case 'default-link':
        if (column.isConditional) {
          return row[column.dataKey] ? <DefaultLink /> : null
        } else {
          return <DefaultLink />
        }
      case 'delete':
        return <IconTrashCan onClick={(e) => {
          e.stopPropagation()
          actions.delete(row)
        }} />
      case 'edit':
        return <IconEdit onClick={() => actions[column.dataKey](row)} />
      case 'text-prefix':
        return column.prefix + row[column.dataKey]
      case 'text-postfix':
        const amount = row[column.dataKey]
        return amount + ' ' + ((amount === 0 || amount > 1) ? column.postfix + 's' : column.postfix)
      case 'blank':
        return <span className="table__empty-cell"></span>
      case '--':
        return <span className="table__empty-cell table__empty-cell--dash-dash">--</span>
      case 'number':
        return <span className='table__dollar' style={column.cellPadding ? { padding: column.cellPadding } : {}}>
          {row[column.dataKey] && row[column.dataKey].toFixed(2)}
        </span>

      case 'text':
      case 'notes':
      default:
        return <span style={column.cellPadding ? { padding: column.cellPadding } : {}}>{row[column.dataKey]}</span>
    }
  }

  return (
    <div className="table__body">
      <ul className="table__body-list"
          key={''}
      >
        {data.map((row, i) => (
          <li key={`unvis${row.id}-${i}`}>
            <div
              className="table__row--clickable table__row"
            >
              <ul
                className="table__row-list-print"
              >
                {options.columns.map(column => (
                  <li
                    className={
                      column.flexGrow
                        ? `${column.flexGrow} table__row-item table__row-item--${column.type}`
                        : `table__row-item table__row-item--${column.type}`
                    }
                    title={column.type === 'notes' ? row.notes : ''}

                  >
                    {cellGenerator(column, row)}
                  </li>
                ))}
              </ul>
            </div>
            {

              <ul className="table__body-list table__body-list--children">
                {row[options.childrenKey] && row[options.childrenKey].map(row => (
                  <li
                    className="table__row--clickable table__row table__row--children"
                    key={`sub-row-${row.id}`}
                  >
                    <ul
                      className="table__row-list-print"

                    >
                      {options.childrenColumns.map(column => (
                        <li
                          className={
                            column.flexGrow
                              ? `${column.flexGrow} table__row-item table__row-item--${column.type}`
                              : `table__row-item table__row-item--${column.type}`
                          }
                          title={column.type === 'notes' ? row.notes : ''}

                        >
                          {cellGenerator(column, row)}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            }
          </li>
        ))}
      </ul>
    </div>
  )
}

export default withRouter(TableBody)
